module.exports = __webpack_public_path__ + "static/media/powered-by-gamanza-black.35c2af59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/powered-by-gamanza-black.svg
// module id = 67
// module chunks = 0